import { Container, Grid, Typography } from "@mui/material";
import MenuService from "../../components/Menu/menuService";
import { useEffect } from "react";

const PrivacyPolicy = () => {
  const boldWeight = 700;
  const titleStyle = { fontWeight: boldWeight, fontSize: "1.5rem !important" };

  const { selectPage } = MenuService();

  useEffect(() => {
    selectPage("privacy-policy");
  }, []);

  return (
    <Container maxWidth="lg">
      <Grid
        item
        container
        sx={{
          backgroundColor: "white",
          marginTop: "30px",
          marginBottom: "100px",
        }}
        direction="column"
        rowSpacing={2}
        alignItems={"left"}
      >
        <Grid item>
          <Typography variant="h1">Privacy Statement</Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Collecticos
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            Collecticos is the premier global platform for football shirt
            collectors. On our platform, you can easily track your own
            collection, discover items from other users, and connect with fellow
            collectors. While users can make private offers for items they are
            interested in, Collecticos is not involved in these transactions.
            Our platform provides an online community where collectors can
            exchange ideas and insights and use our messaging system to get in
            touch with each other. Access to our platform is available through
            our website, including all subdomains, as well as mobile versions
            and apps ("the Website"). As part of using our Website, we process
            personal data. In this Privacy Statement, we explain how we handle
            your personal data.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Contact details
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            Collecticos B.V. (“Collecticos”, “we”, “us”, or “our”) is
            responsible for processing your personal data, with its address at
            John M. Keynesplein 12-46, 1066 EP Amsterdam. Collecticos is
            registered with the Chamber of Commerce under number [XXXXXX]. Any
            questions regarding the processing of personal data by Collecticos
            can be addressed to info@collecticos.com.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            To whom does this Privacy Policy apply?
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            This Privacy Statement applies to you when you use our Website.
            Through our platform, you can create and manage a collection,
            explore other users' collections, engage with the community, and
            exchange private messages with other users. You can also contact us
            via the Website and subscribe to our newsletter.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            How does Collecticos process your personal data?
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            We process your personal data for various purposes, as outlined
            below. We only do so when we have a legal basis for processing
            (referred to as a legal ground). The following overview explains how
            we use your data, the purpose of processing it, and how long we
            store the data.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Visiting the Website
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            When you visit the Website, we collect technical information about
            your visit, such as the date and time, IP address, browser type, and
            the pages you visit. This data is essential for the optimal
            functioning of the Website and to display information correctly. We
            also collect data via cookies to enhance your browsing experience.
            For more information, please refer to our Cookie Statement.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Newsletter
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            Collecticos offers the option to subscribe to newsletters and
            marketing communications. When you subscribe, we collect your email
            address and may use tracking software to monitor engagement with the
            emails. If you choose to unsubscribe, you can do so through the
            opt-out option in every newsletter. We retain your email address for
            up to 5 years after you unsubscribe.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Creating and using a profile
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            a. Profile Creation. When you create a profile, we register your
            email and password.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            b. Managing Collections. You can create and manage collections and
            explore others' collections. Information about your collection will
            be visible to other users.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            c. Private Offers. You can make private offers for items of
            interest, but Collecticos is not involved in these transactions.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            d. Messaging. Users can exchange messages privately via the
            messaging system on the platform
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Personalized ads
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            We use personal data to offer personalized recommendations or
            promotions via email or on the Website. We base these offers on your
            activity, profile, and purchase or browsing behavior. This
            processing is necessary for our legitimate interest in offering
            relevant content and marketing to users.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Security and fraud prevention
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            We use your personal data to ensure the security of our systems,
            prevent fraud, and protect our platform. This includes technical
            data such as IP address and activity logs. This is necessary for our
            legitimate interest in maintaining a secure and reliable platform.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Payments
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            If you make a payment on our platform, your transaction details are
            processed by our payment service providers. While we record
            transaction details, we do not handle payment data directly. We
            advise you to review the privacy policies of our payment processors.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Contact
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            If you contact us, we process the information you provide, such as
            your name, email, and the content of your message, to respond to
            your query. We retain this data for up to one year after resolving
            your inquiry.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Access to personal data
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            We may share your data with the following third parties:
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Other users
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            Collecticos users can view your public profile and collections.
            Private messages are only shared between the relevant users.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Service Providers
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            We work with service providers who may process your personal data on
            our behalf, such as website hosting and newsletter distribution.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Authorities
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            We may share personal data with legal authorities if required by law
            or regulation, or in the case of a legal request.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Your rights
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1"></Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Complaints or questions
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            If you have any complaints or questions, feel free to contact us via
            info@collecticos.com. You can also submit a complaint to the Dutch
            Data Protection Authority (Autoriteit Persoonsgegevens).
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" sx={titleStyle}>
            Amendments
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            Collecticos may amend this Privacy Statement from time to time. If
            there are significant changes, we will notify users.
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default PrivacyPolicy;
